import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'Prime Sentinel Insurance Solutions';
const BASE = 'https://primesentinelins.com';

const META = {
  '/': {
    title: `${SITE} | Business & Transportation Insurance`,
    description: 'Commercial, transportation, and personal insurance backed by 30+ A-rated carriers. Protect your business and get a free quote today.',
  },
  '/about': {
    title: `About Us | ${SITE}`,
    description: 'Learn about Prime Sentinel Insurance Solutions — our mission, values, and commitment to protecting businesses and families.',
  },
  '/products': {
    title: `Insurance Products | ${SITE}`,
    description: 'Explore commercial and personal insurance products, from business owners policies and transportation coverage to homeowners and umbrella protection.',
  },
  '/transportation': {
    title: `Transportation Insurance | ${SITE}`,
    description: 'Specialized trucking and transportation insurance — auto liability, cargo, physical damage, and more for fleets of every size.',
  },
  '/certificate': {
    title: `Download Your COI | ${SITE}`,
    description: 'Search and download your Certificate of Insurance quickly and securely.',
  },
  '/get-quote': {
    title: `Get a Free Quote | ${SITE}`,
    description: 'Request a free, no-obligation insurance quote tailored to your business or personal needs.',
  },
  '/contact': {
    title: `Contact Us | ${SITE}`,
    description: 'Get in touch with Prime Sentinel Insurance Solutions. We are here to answer your questions and help protect what matters most.',
  },
  '/financing': {
    title: `Premium Financing | ${SITE}`,
    description: 'Flexible premium financing options that make it easier to manage your insurance payments.',
  },
  '/careers': {
    title: `Careers | ${SITE}`,
    description: 'Build a career with purpose at Prime Sentinel Insurance Solutions. Explore openings and internships in a stable, growing industry.',
  },
  '/privacy-policy': {
    title: `Privacy Policy | ${SITE}`,
    description: 'How Prime Sentinel Insurance Solutions collects, uses, and protects your information.',
  },
};

function metaFor(pathname) {
  if (META[pathname]) return META[pathname];
  if (pathname.startsWith('/products/')) {
    return {
      title: `Insurance Coverage | ${SITE}`,
      description: 'Detailed coverage information and a free quote for this insurance product from Prime Sentinel Insurance Solutions.',
    };
  }
  if (pathname.startsWith('/admin')) {
    return { title: `Admin | ${SITE}`, description: '' };
  }
  return {
    title: SITE,
    description: 'Commercial, transportation, and personal insurance backed by 30+ A-rated carriers.',
  };
}

function setMeta(name, content) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setCanonical(href) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

export default function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const { title, description } = metaFor(pathname);
    document.title = title;
    if (description) setMeta('description', description);
    setCanonical(BASE + pathname);
  }, [pathname]);
  return null;
}